<template>
  <div class="container">
    <form ref="tributeForm" v-on:submit.prevent="noop" class="tribute-form w-100">
      <b-field>
        <b-input maxlength="2000"
                 type="textarea"
                 v-model="tributeForm.comment"
                 required
                 placeholder="Write a message (留言)"></b-input>
      </b-field>
      <b-field>
        <b-input maxlength="30"
                 v-model="tributeForm.user"
                 required
                 placeholder="Your name (您的姓名)">
        </b-input>
      </b-field>
      <div class="field">
        <div class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="tributeForm.flower" />Leave a flower (献上一束花)
          </label>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="tributeForm.candle" /> Leave a candle (献上一支蜡烛）
          </label>
        </div>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <div class="control">
          <vue-recaptcha ref="recaptcha"
                         @verify="onCaptchaVerified"
                         @expired="onCaptchaExpired"
                         size="invisible"
                         :loadRecaptchaScript="true"
                         sitekey="6Lf4TOwUAAAAAC9fCk5rix3OZVYAihYpP_sFLKi2">
          <button :disabled="disabled"
                  v-on:click.stop.prevent="submitForm"
                  class="button is-primary">Submit</button>
          </vue-recaptcha>
        </div>
      </div>
    </form>
  </div>
</template>
<style lang="scss">
@import "@/assets/vars.scss";

.form-container .content {
  padding: 2em;
  border-radius: 10px;
  background-color: $light-bg;
  color: $light-txt;
}
</style>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'TributeForm',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      tributeForm: {
        comment: '',
        user: '',
        flower: false,
        candle: false,
      },
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    initForm() {
      this.tributeForm.comment = '';
      this.tributeForm.user = '';
      this.tributeForm.flower = false;
      this.tributeForm.candle = false;
    },
    resetForm(evt) {
      evt.preventDefault();
      this.initForm();
    },
    submitForm(evt) {
      evt.preventDefault();
      if (!this.$refs.tributeForm.checkValidity()) {
        this.$refs.tributeForm.reportValidity();
      } else {
        this.$refs.recaptcha.execute();
      }
    },
    onCaptchaVerified(tkn) {
      this.$refs.recaptcha.reset();
      if (!this.$refs.tributeForm.checkValidity()) {
        this.$refs.tributeForm.reportValidity();
      } else {
        this.$emit('submit', {
          formData: this.tributeForm,
          token: tkn,
        });
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    noop() {
      // Do Nothing
    },
  },
};
</script>
